import { Type } from '@angular/core';
import { Routes } from '@angular/router';
import { AuthorizationGuard } from '@orion-platform/core'; // Note: You may need to convert this to a functional guard later
import { plantFromUrlGuard } from './guards/plant-from-url.guard';

export const routes: Routes = [
  {
    data: {
      breadcrumb: 'login',
    },
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    data: {
      breadcrumb: 'login',
    },
    loadComponent: (): Promise<Type<unknown>> =>
      import('./public/login/login.component').then((m): Type<unknown> => m.LoginComponent),
    path: 'home',
  },
  {
    canActivate: [AuthorizationGuard],
    data: {
      breadcrumb: 'dashboard',
      preload: true,
    },
    // NEW STYLE: Load the Routes array directly, not the Module
    loadChildren: (): Promise<Routes> =>
      import('./features/scm/material-management/v1/material-management.routes').then(
        (m): Routes => m.MATERIAL_MANAGEMENT_ROUTES,
      ),
    path: 'dashboard',
  },
  {
    canActivate: [AuthorizationGuard],
    data: {
      breadcrumb: 'material-management',
    },
    loadChildren: (): Promise<Routes> =>
      import('./features/scm/material-management/v1/material-management.routes').then(
        (m): Routes => m.MATERIAL_MANAGEMENT_ROUTES,
      ),
    path: 'material-management',
  },
  {
    // The plant guard runs before the module's routes are activated, so a link
    // that names a plant is already in it by the time the first request goes out.
    canActivate: [AuthorizationGuard, plantFromUrlGuard],
    data: {
      breadcrumb: 'material-management',
    },
    loadChildren: (): Promise<Routes> =>
      import('./features/scm/material-management/v1/material-management.routes').then(
        (m): Routes => m.MATERIAL_MANAGEMENT_ROUTES,
      ),
    path: ':plant/material-management',
  },
  {
    canActivate: [AuthorizationGuard],
    data: {
      breadcrumb: 'self-billing',
    },
    loadChildren: (): Promise<Routes> =>
      import('./features/scm/material-management/v1/material-management.routes').then(
        (m): Routes => m.MATERIAL_MANAGEMENT_ROUTES,
      ),
    path: 'financial-module',
  },
  {
    canActivate: [AuthorizationGuard],
    data: {
      breadcrumb: 'logistic',
    },
    loadChildren: (): Promise<Routes> =>
      import('./features/scm/material-management/v1/material-management.routes').then(
        (m): Routes => m.MATERIAL_MANAGEMENT_ROUTES,
      ),
    path: 'logistic',
  },
  {
    canActivate: [AuthorizationGuard],
    data: {
      breadcrumb: 'ai',
    },
    loadChildren: (): Promise<Routes> =>
      import('./features/scm/material-management/v1/material-management.routes').then(
        (m): Routes => m.MATERIAL_MANAGEMENT_ROUTES,
      ),
    path: 'ai',
  },
  {
    loadChildren: (): Promise<Routes> =>
      import('./public/not-found/not-found.routes').then((m): Routes => m.NOT_FOUND_ROUTES), // Assuming you convert this too
    path: '404',
  },
  {
    loadChildren: (): Promise<Routes> =>
      import('./public/unauthorized/unauthorized.routes').then(
        (m): Routes => m.UNAUTHORIZED_ROUTES,
      ), // Assuming you convert this too
    path: 'unauthorized',
  },
  {
    data: {
      breadcrumb: 'not-found',
    },
    path: '**',
    redirectTo: 'dashboard',
  },
];
